export const POPUP_DISPLAY = {
  AUTO_DISPLAY_POPUPS: { //HAVE TO BE THE SAME NAME AS IN REMOTE CONFIG JSON
    didomi: 'Didomi',
    bp: 'BP',
    wizard: 'Wizard',
    dynamicPopup: 'DynamicPopup',
  }
}